import { paths } from "@/router";
import { Redirect } from "react-router-dom";

const RedirectToApps = () => {
  return <Redirect to={paths.ssoRoute.apps.apps} />;
};

export default RedirectToApps;
